import CustomFieldDisplay from 'components/forms/inputs/custom-fields/CustomFieldDisplay';
import { groupFieldsByHeaders } from 'components/forms/inputs/custom-fields/useCustomFields';
import GridItemList from 'components/GridItemList';
import cloneDeep from 'lodash/cloneDeep';
import { ReactNode, useMemo } from 'react';
import { ClassifierData } from 'types/classifiers';
import { CustomField } from 'types/customFields';
import { t } from 'utils/getTranslations';

interface Props {
    /** The record's custom fields, headers included: each header starts a card. */
    fields: CustomField[];
    classifiers: ClassifierData[];
    /** The Edit of the whole set, in the first card's header: one form edits them all. */
    edit: ReactNode;
}

/** A record's custom fields in the new design's cards, one card per header group. */
export default function CustomFieldCards({ fields, classifiers, edit }: Props) {
    const groups = useMemo(() => groupFieldsByHeaders(cloneDeep(fields)), [fields]);
    return (
        <>
            {groups.map(({ id, section, fields: groupFields, shouldTranslate }, index) => (
                <GridItemList
                    isNew
                    key={`${id}_${section}`}
                    titleId={section}
                    shouldTranslate={shouldTranslate}
                    button={index === 0 ? edit : null}
                    data={groupFields.map((field) => ({
                        label: field.label ? (field.shouldTranslate ? t(field.label) : field.label) : '',
                        content: <CustomFieldDisplay field={field} classifiers={classifiers} />,
                    }))}
                />
            ))}
        </>
    );
}
